import { get, patch, post, httpDelete } from 'store/http/httpAction';
import _ from 'lodash';
import EnumsManager from 'utils/EnumsManager';
import { setStore } from 'utils/localStorage';
import { fetchLoginUserDetail } from 'store/global/action';
import { SETUP_USERS_TOGGLE_DEPARTMENT_SELECT_DIALOG, SETUP_USERS_DEPARTMENT, SETUP_USERS_PAGENATIONS, SETUP_USERS_USERS, SETUP_USERS_EDIT_USER, SETUP_USERS_SEARCHKEY, SETUP_USERS_SCOPE_VALUE, SETUP_USERS_LAST_PAGE, SETUP_USERS_INCREMENT_TOTAL } from './actionType';

const { LocalStorageKeys } = EnumsManager;
const { User } = LocalStorageKeys;

export const setEditUser = user => ({
  type: SETUP_USERS_EDIT_USER,
  user,
});
export const toggleDepartmentDialog = visible => ({
  type: SETUP_USERS_TOGGLE_DEPARTMENT_SELECT_DIALOG,
  isDisplayDepartmentDialog: visible,
});

export const setDepartment = args => ({
  type: SETUP_USERS_DEPARTMENT,
  ...args,
});

export const setUserData = users => ({
  type: SETUP_USERS_USERS,
  users,
});

const setPaginations = (perPage, currentPage, total) => ({
  type: SETUP_USERS_PAGENATIONS,
  perPage,
  currentPage,
  total,
});

export const incrementPaginationTotal = () => ({
  type: SETUP_USERS_INCREMENT_TOTAL,
});

export const setPaginationLastPage = () => ({
  type: SETUP_USERS_LAST_PAGE,
});

export const setSearchKey = searchKey => ({
  type: SETUP_USERS_SEARCHKEY,
  searchKey,
});

export const setScopeValue = scope => ({
  type: SETUP_USERS_SCOPE_VALUE,
  scope
});

export const fetchUsers = (perPage = EnumsManager.DefaultPageConfigs.PageSize, currentPage = 1, search, scope) => (dispatch) =>
  get('/admin/users/list', {
    scope, per_page: perPage, page: currentPage, search
  }, dispatch).then((data) => {
    if (data && data.data && data.meta) {
        //give default status to offline
        let dataWithStatus = data.data.map(item => {
          const pair = {status: 'offline'}
          item = {...item, ...pair}
          return item
        })
        get('/admin/online/users', {}, dispatch).then((onlineStatus) => {
          //set the online status to online
          for(let i = 0; i < onlineStatus.length; i++){
            for(let j = 0; j < dataWithStatus.length; j++){
                if(dataWithStatus[j].id == onlineStatus[i]){
                  const pair = { status: 'online' }
                  dataWithStatus[j] = {...dataWithStatus[j], ...pair}
                }
              }
          }
          dispatch(setUserData(dataWithStatus));
          const { pagination } = data.meta;
        dispatch(setPaginations(pagination.per_page, pagination.current_page, pagination.total));
      });
    }
  });

export const queryByPaging = (perPage, currentPage, scope) => (dispatch, getState) => {
  const state = getState();
  const { searchKey } = state.setup.users.searchKey;
  dispatch(fetchUsers(perPage, currentPage, searchKey, scope));
};


export const queryBySearchKey = (searchKey, scope) => (dispatch, getState) => {
  const { perPage } = getState().setup.users.usersDataTablePagination;
  dispatch(setSearchKey(searchKey));
  dispatch(fetchUsers(perPage, 1, searchKey, scope));
};

export const getCountryCallingCode = () => dispatch => get('/admin/global-setting/country-calling-code', dispatch).then((res) => res.data);

export const updateUsers = (form, cb) => dispatch => patch(`/admin/users/${form.id}`, { ...form }, dispatch).then(() => {
  if (_.isFunction(cb)) {
    cb();
  }
});

export const addUsers = (form, callback) => dispatch => post('/admin/users', { ...form }, dispatch).then((data) => {
  if (!_.isEmpty(data) && _.isFunction(callback)) {
    callback();
  }
});

export const deleteUsers = (id, scope, cb) => (dispatch, getState) => httpDelete(`/admin/users/${id}`, {}, dispatch).then((data) => {
  if (!_.isEmpty(data)) {
    if (_.isFunction(cb)) {
      cb(data);
      dispatch(setScopeValue(scope));
    }
  }
});

export const fetchEditUser = (id, cb) => dispatch => get(`/admin/users/${id}`, {}, dispatch).then((data) => {
  if (!_.isEmpty(data.data)) {
    dispatch(setEditUser(data.data));
    if (_.isFunction(cb)) {
      cb(data.data);
    }
  }
});

export const loginAsUser = (userId, cb) => dispatch => post(`/admin/users/${userId}/login_as`, {}, dispatch).then(async data => {
  if (!_.isEmpty(data)) {
    await setStore(User, {
      token_info: data
    });
    dispatch(fetchLoginUserDetail(cb));
  }
});



// WEBPACK FOOTER //
// ./src/views/Setup/Users/flow/action.js